import * as types from "../actionTypes";

const initialState = {}

export default function company(state = initialState, action) {
  switch (action.type) {
    case types.COMPANY_RECEIVE:
      return {
        ...state,
        ...action.payload,
      };

    case types.COMPANY_HYDRATE:
      return { ...state, ...action.payload }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/company/reducers/company.js